import type {
  ActionInstanceStep,
  ActionInstanceStepComment,
  ActionInstanceStepCommentDTO,
  ActionInstanceStepCommentCreatePayload,
  ActionInstanceStepDTO,
  PatchActionInstanceStepPayload,
  StatusLog,
  StatusLogDTO,
} from './actionInstanceStep.types';

export const parseActionInstanceStepForFE = (dto: ActionInstanceStepDTO): ActionInstanceStep => ({
  id: dto.id,
  title: dto.title,
  instruction: dto.instruction,
  mandatory: dto.mandatory,
  mandatoryTooltip: dto.mandatory_tooltip ?? undefined,
  order: dto.order,
  status: dto.status,
  statusDisplay: dto.status_display,
  blockReason: dto.block_reason ?? undefined,
  completionComment: dto.completion_comment ?? undefined,
});

export const parsePatchActionInstanceStepForBE = (
  payload: PatchActionInstanceStepPayload,
): { status?: string; block_reason?: string; completion_comment?: string } => {
  const body: { status?: string; block_reason?: string; completion_comment?: string } = {};
  if (payload.status != null) body.status = payload.status;
  if (payload.blockReason !== undefined) body.block_reason = payload.blockReason;
  if (payload.completionComment !== undefined) body.completion_comment = payload.completionComment;
  return body;
};

export const parseActionInstanceStepCommentForFE = (dto: ActionInstanceStepCommentDTO): ActionInstanceStepComment => ({
  id: dto.id,
  text: dto.text,
  userEmail: dto.user_email,
  userFullName: dto.user_full_name,
  createdAt: dto.created_at,
  updatedAt: dto.updated_at,
});

export const parseActionInstanceStepCommentListForFE = (dtos: ActionInstanceStepCommentDTO[]): ActionInstanceStepComment[] =>
  dtos.map(parseActionInstanceStepCommentForFE);

export const parseActionInstanceStepCommentCreateForBE = (payload: ActionInstanceStepCommentCreatePayload): { text: string } => ({
  text: payload.text,
});

export const parseStatusLogForFE = (dto: StatusLogDTO): StatusLog => ({
  id: dto.id,
  user: dto.user,
  userEmail: dto.user_email,
  userFullName: dto.user_full_name,
  oldStatus: dto.old_status,
  oldStatusDisplay: dto.old_status_display,
  newStatus: dto.new_status,
  newStatusDisplay: dto.new_status_display,
  createdAt: dto.created_at,
});

export const parseStatusLogListForFE = (dtos: StatusLogDTO[]): StatusLog[] => dtos.map(parseStatusLogForFE);
